
import { Component, Vue, Prop } from "vue-property-decorator";
import { IPrj, Prj } from "@/prj/IPrj";
import { IUser } from "@/../../server/src/user/IUser";
import Store from "@/store/Store"; 
import { MasterData } from "@/store/MasterData"; 
import Bus from "@/lib/Bus"
import { IFinder, Finder } from "../finder/IFinder";
import { Debouncer } from "@/lib/Debouncer"
import  ClipUseVue from "@/clip/ClipUse.vue";
import  ClipAddVue from "@/clip/ClipAdd.vue";
import  ClipUseMultiVue from "@/clip/ClipUseMulti.vue";
import  ClipAddMultiVue from "@/clip/ClipAddMulti.vue";
import SearcherVue from "@/searcher/Searcher.vue"

const bus: Bus = new Bus().getBus();

import ButtonVue from "@/lib/Button.vue"

import PrjVue from "../prj/Prj.vue";
Vue.component("Prj", PrjVue);


import FinderVue from "@/finder/Finder.vue";
import { Searcher } from "@/searcher/Searcher";
Vue.component("Finder", FinderVue);

@Component({ components: { PrjVue, ButtonVue,ClipAddVue,SearcherVue } })
export default class PrjsVue extends Vue {
  prjs: IPrj[] = [];
  //user: IUser | undefined;
  limit:number=99;
  filter: string = "";
  key0: number = 0;
  key: number = 1;
  listKey: number = 0;
  k1:number=0;
  maximized_id:string|undefined="";
  prj_finder:IFinder = new Finder();
  debounced:any;
  searcher: Searcher = new Searcher();

  created() {
    bus.register("on_login", this.on_login);
  }

  async on_login(e:any) {
    const user: IUser | undefined = window.user;
    console.log("on_login",user)
    if (!user) {
      this.prjs = []
    } else {
      await this.refresh()
    }
    this.key0++;
  }

  show_prj(_id:string) {
    window.router.push({ path: `/projekty/${_id}` }) 
    this.k1++
  }

  async mounted() {
    const masterData: MasterData|undefined = await (await new Store().getStore()).masterData;
    this.debounced = Debouncer.debounce(await (this.refresh.bind(this)), 1000).bind(this);
    //await this.refresh();
  }

  async add() {
    let prj: IPrj = new Prj()
    prj = <IPrj> await bus.call("/api/projekt/add", prj)
    if (prj) {
      this.prjs.push(prj)
      this.show_prj(prj._id as string);
    }
  }

  async del(prj:any) {1
    if(!confirm("Skasować projekt?")) return;
    
    const prjnew = <IPrj> await bus.call("/api/projekt/del", prj)
    console.log(prjnew)
    if (prjnew) {
      if (prjnew._err.msg) {
        alert(prjnew._err.msg)
      } else {
        alert("Projekt został skasowany")
        prj.del=1
        this.key++; 
      }
     
    }
  }

  searcher_changed(searcher:Searcher) {
    this.refresh();
    this.key++;
  }


  async debounce() {
    await this.debounced()
  }
  
  async refresh() {
    console.log('********************** refesh')
    this.prjs=[]
    let prjs: IPrj[]|undefined = undefined;
    
    prjs = await await bus.call("/api/projekt/find_projekty_short",   this.searcher )
    if (prjs) {
      this.prjs=prjs;
    }
    this.listKey++
  }

  selected(id:any) {
    if (!this.$route.params.prj_id) return '';
    if (this.$route.params.prj_id==id ) return 'selected-row';
    return '';
  }
  
}
